import { Component, Input, OnInit } from '@angular/core';
import {
  EmployeePay,
  MasterPayrollObject,
  OpenPaylineDetailsArgs,
  Payline,
  PaylineType,
  PayrollStartData,
  SelectedPaylineArgs
} from '../../../models/payroll';
import { HistoryVoidSelection } from './history-void-selection/history-void-selection.component';
import { PayrollManagement } from '../../../tools/payroll-management';
import { Client } from '../../../models/client';
import { LaborAllocationTypes } from '../../../models/labor-allocation';

export enum AddPaylineViewStates {
  SelectType = 0,
  HistoryVoidSelection = 1,
  HistoryVoidDetails = 2,
  NoCheckDetails = 3
}
@Component({
  selector: 'lib-add-payline-type',
  templateUrl: './add-payline-type.component.html',
  standalone: false
})
export class AddPaylineTypeComponent implements OnInit {
  @Input() deductionConfigs: {};
  @Input() earningConfigs: {};
  @Input() historyVoidPayrolls: MasterPayrollObject[] = [];
  @Input() onAddHistoryVoid: any;
  @Input() onAddRegularPay: any;
  @Input() onAddNoCheck: any;
  @Input() onClose: any;
  @Input() onDismiss: any;
  @Input() startData: PayrollStartData;
  @Input() taxConfigs: {};
  @Input() selectedPaylineArgs: SelectedPaylineArgs;
  @Input() payroll: MasterPayrollObject;
  @Input() client: Client;

  public newPayline: Payline;
  public employeePay: EmployeePay;
  public personName: string;
  public historyVoidDetailArgs: OpenPaylineDetailsArgs;
  public noCheckDetailArgs: OpenPaylineDetailsArgs;
  public selHistoryVoid: HistoryVoidSelection;
  public typeSelection: number = 0;

  public viewState: AddPaylineViewStates = AddPaylineViewStates.SelectType;

  public viewStateHeaders = {
    0: 'Add New Pay',
    1: 'Add History Void',
    2: 'Add History Void',
    3: 'Add No Check Record'
  };

  public get paylineTypes() {
    return PaylineType;
  }

  public get viewStates() {
    return AddPaylineViewStates;
  }

  constructor(private payrollMgmt: PayrollManagement) {}

  ngOnInit(): void {
    // FIXME - This early return seems like a trap for future development.  Should this just be setting a flag
    // that there are no history voids instead?
    if (!this.historyVoidPayrolls?.length || !this.historyVoidPayrolls[0].EmployeePays?.length) {
      return;
    }

    const e = this.historyVoidPayrolls[0].EmployeePays[0];

    this.personName = `${e.EmployeeFirstName || ''}${
      e.EmployeeMiddleName ? ' ' + e.EmployeeMiddleName : ''
    } ${e.EmployeeLastName || ''}`.trim();
  }

  public onContinue() {
    if (this.typeSelection == this.paylineTypes.Normal) {
      this.onAddRegularPay();
    } else if (this.typeSelection == this.paylineTypes.Void) {
      this.viewState = AddPaylineViewStates.HistoryVoidSelection;
    } else if (this.typeSelection == this.paylineTypes.NoCheck) {
      this.payrollMgmt
        .addPayline(
          this.payroll.ClientCode,
          this.payroll.Year,
          this.payroll.SequenceNumber,
          this.selectedPaylineArgs.PersonId,
          {
            PaylineType: PaylineType.NoCheck,
            HistoryVoidData: null
          }
        )
        .subscribe(res => {
          this.newPayline = res.line as Payline;
          this.employeePay = res.pay as EmployeePay;
          this.payroll = res.payroll as MasterPayrollObject;

          this.noCheckDetailArgs = {
            Payline: this.newPayline,
            PaylineId: this.newPayline.PaylineId,
            RowId: this.selectedPaylineArgs.RowId,
            RowIndex: this.selectedPaylineArgs.RowIndex,
            IsDirty: true,
            IsReadOnly: false,
            OpenInModal: false,
            PersonId: this.employeePay.PersonId,
            NeedsCalculation: false
          };

          this.viewState = AddPaylineViewStates.NoCheckDetails;
        });
    }
  }

  public onVoidDetailBack() {
    this.viewState = AddPaylineViewStates.HistoryVoidSelection;
  }

  public onNoCheckDetailBack() {
    this.onAddNoCheck(this.employeePay, this.newPayline);
    this.viewState = AddPaylineViewStates.SelectType;
  }

  public onNoCheckDetailContinue(result: { emp: EmployeePay; line: Payline }) {
    this.newPayline = result.line;
    this.employeePay = result.emp;
    this.onAddNoCheck(this.employeePay, this.newPayline);
  }

  public onVoidDetailContinue() {
    this.onAddHistoryVoid(this.historyVoidDetailArgs);
  }

  public onVoidSelectionBack() {
    this.viewState = AddPaylineViewStates.SelectType;
  }

  public onVoidSelectionContinue(selection: HistoryVoidSelection) {
    if (selection) {
      this.selHistoryVoid = selection;
    }

    this.employeePay = this.selHistoryVoid.Payroll.EmployeePays[0];
    this.employeePay.Paylines.forEach(x => (x.PaylineType = PaylineType.Void));

    this.viewState = AddPaylineViewStates.HistoryVoidDetails;

    this.historyVoidDetailArgs = new OpenPaylineDetailsArgs(
      null,
      this.selHistoryVoid.Payline.PaylineId,
      this.selHistoryVoid.Payroll.EmployeePays[0].PersonId,
      null,
      null,
      false,
      true,
      false,
      this.selHistoryVoid.Payline
    );
  }
}
